import Reveal from "@/components/site/Reveal";
import SectionTitle from "@/components/site/SectionTitle";

const points = [
  {
    icon: "ri-wifi-off-line",
    title: "S'ouvre sans réseau",
    text: "L'application est gardée sur l'ordinateur ou le téléphone : elle s'ouvre même quand la connexion est coupée.",
  },
  {
    icon: "ri-search-eye-line",
    title: "Consulter et imprimer",
    text: "Élèves, parents, classes, paiements et impayés restent consultables. Bulletins, cartes et fiches s'impriment.",
  },
  {
    icon: "ri-edit-box-line",
    title: "Continuer à travailler",
    text: "Notes, encaissements et inscriptions se saisissent hors ligne. Le reçu numéroté s'imprime dès l'envoi.",
  },
  {
    icon: "ri-refresh-line",
    title: "Envoi automatique, sans doublon",
    text: "Au retour du réseau, tout part tout seul, dans l'ordre. Une même action n'est jamais enregistrée deux fois.",
  },
];

const queue = [
  { label: "Notes — Évaluation d'octobre, Calcul", meta: "CM1 · 32 élèves" },
  { label: "Paiement — DIALLO Aïssatou", meta: "150 000 FG · sans reçu pour l'instant" },
  { label: "Inscription — CAMARA Mamadou", meta: "CP1 · photo comprise" },
];

/** Site public : le mode hors ligne, pensé pour les coupures de réseau. */
export default function OfflineSection() {
  return (
    <section id="hors-ligne" className="scroll-mt-28 overflow-hidden bg-primary-950 py-20 md:py-28">
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-12 px-4 md:px-6 lg:grid-cols-[1.05fr_1fr] lg:gap-16">
        <div>
          <SectionTitle
            invert
            eyebrow="Même sans connexion"
            title="Une coupure de réseau n'arrête plus l'école"
            intro="WaitechEdu continue de fonctionner hors ligne pendant 3 jours. Le travail fait sans connexion est envoyé tout seul dès que le réseau revient."
          />
          <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2">
            {points.map((p, index) => (
              <Reveal key={p.title} delay={index * 80}>
                <div className="flex gap-3.5">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/10 text-primary-200" aria-hidden="true">
                    <i className={`${p.icon} text-lg`}></i>
                  </span>
                  <div>
                    <h3 className="font-semibold font-heading text-white">{p.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-white/70">{p.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
          <p className="mt-8 inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm text-white/85">
            <i className="ri-smartphone-line text-primary-200" aria-hidden="true"></i>
            S'installe comme une application sur le téléphone et l'ordinateur.
          </p>
        </div>

        {/* Aperçu de l'écran : l'indicateur « Hors ligne » et les actions en attente d'envoi. */}
        <Reveal delay={120}>
          <div className="relative mx-auto w-full max-w-md" aria-hidden="true">
            <span className="absolute -left-6 -top-6 h-40 w-40 rounded-full bg-primary-500/30 blur-3xl"></span>
            <div className="relative rounded-[1.75rem] border border-white/10 bg-white p-5 shadow-modal">
              <div className="flex items-center justify-between">
                <span className="text-sm font-semibold font-heading text-foreground-950">École Les Palmiers</span>
                <span className="inline-flex items-center gap-1.5 rounded-full border border-warning-200 bg-warning-50 px-3 py-1 text-xs font-medium text-warning-800">
                  <i className="ri-wifi-off-line"></i> Hors ligne
                </span>
              </div>
              <p className="mt-4 text-xs font-semibold uppercase tracking-wide text-foreground-500">En attente d'envoi</p>
              <ul className="mt-2 space-y-2">
                {queue.map((q) => (
                  <li key={q.label} className="flex items-center justify-between gap-3 rounded-xl border border-background-200 px-3.5 py-3">
                    <div className="min-w-0">
                      <p className="truncate text-sm font-medium text-foreground-900">{q.label}</p>
                      <p className="text-xs text-foreground-500">{q.meta}</p>
                    </div>
                    <span className="shrink-0 rounded-full bg-primary-50 px-2 py-0.5 text-xs font-medium text-primary-700">En attente</span>
                  </li>
                ))}
              </ul>
              <div className="mt-4 flex items-center gap-2 rounded-xl bg-primary-50 px-3.5 py-3 text-sm text-primary-900">
                <i className="ri-refresh-line text-primary-600"></i>
                Envoi automatique au retour du réseau
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
